import { defineComponent as v, computed as n, createBlock as d, openBlock as r, unref as l, normalizeClass as g, withCtx as h, createCommentVNode as s, resolveDynamicComponent as p, toRaw as y, mergeProps as x } from "vue";
import { RevButtonBase as k } from "@ds/components/ButtonBase";
import { RevSpinner as B } from "@ds/components/Spinner";
import { tw as e } from "../../utils/tailwind.js";
const A = /* @__PURE__ */ v({
  name: "RevButtonIcon",
  __name: "ButtonIcon",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    icon: {},
    loading: { type: Boolean, default: !1 },
    loadingAlternativeText: { default: void 0 },
    alternativeText: { default: void 0 },
    size: { default: "medium" },
    to: { default: void 0 },
    variant: {},
    tracking: { default: () => ({}) }
  },
  emits: ["click"],
  setup(b) {
    const a = b, c = n(() => a.disabled ? "" : a.to), u = n(() => {
      const i = [
        e`focus-visible-outline-default-hi rounded-full`,
        e`flex shrink-0 cursor-pointer appearance-none`,
        e`items-center justify-center`,
        e`border-0`,
        e`no-underline`,
        e`disabled:cursor-not-allowed`,
        e`motion-safe:transition motion-safe:duration-300 motion-safe:ease-in`
      ], t = {
        medium: e`size-40`,
        small: e`size-32`
      }, o = {
        primary: [
          e`bg-action-default-hi text-onaction-default-hi`,
          e`hover:bg-action-default-hi-hover`,
          e`disabled:bg-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        secondary: [
          e`bg-action-default-min text-action-default-hi`,
          e`hover:bg-action-default-min-hover`,
          e`disabled:bg-action-default-min-disabled disabled:text-action-default-hi-disabled`
        ],
        primaryDestructive: [
          e`bg-action-danger-hi text-onaction-danger-hi`,
          e`hover:bg-action-danger-hi-hover`,
          e`disabled:bg-action-danger-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        secondaryDestructive: [
          e`bg-action-danger-min text-action-danger-hi`,
          e`hover:bg-action-danger-min-hover`,
          e`disabled:bg-action-danger-min-disabled disabled:text-action-danger-hi-disabled`
        ]
      };
      return [i, t[a.size], o[a.variant]];
    }), f = n(() => ({ alternativeText: a.alternativeText })), m = n(() => a.loading && a.loadingAlternativeText ? a.loadingAlternativeText : a.ariaLabel ? a.ariaLabel : a.alternativeText);
    return (i, t) => (r(), d(l(k), {
      "aria-describedby": i.ariaDescribedby,
      "aria-label": m.value,
      "aria-labelledby": i.ariaLabelledby,
      class: g(u.value),
      disabled: i.disabled,
      to: c.value,
      tracking: i.tracking,
      onClick: t[0] || (t[0] = (o) => i.$emit("click", o))
    }, {
      default: h(() => [
        i.loading ? s("", !0) : (r(), d(p(y(i.icon)), x({ key: 0 }, f.value, { "aria-hidden": "true" }), null, 16)),
        i.loading ? (r(), d(l(B), {
          key: 1,
          "alternative-text": i.loadingAlternativeText
        }, null, 8, ["alternative-text"])) : s("", !0)
      ]),
      _: 1
    }, 8, ["aria-describedby", "aria-label", "aria-labelledby", "class", "disabled", "to", "tracking"]));
  }
});
export {
  A as default
};
